import React, { useState, useEffect } from "react";
import "./nav.css";
import { userIcon, cartIcon, heartIcon } from "../utils/Icons";

export default function Nav({ handleInputChange }) {
  return (
    <nav>
      <div className="nav-container">
        <input
          type="text"
          className="search-input"
          placeholder="Enter the search shoes"
          onChange={(e) => handleInputChange(e.target.value)}
        />
      </div>
      <div className="nav-container">
        <a href="#">{userIcon}</a>
        <a href="#">{cartIcon}</a>
        <a href="#">{heartIcon}</a>
      </div>
    </nav>
  );
}
